import { render, staticRenderFns } from "./deleteSegment.vue?vue&type=template&id=6d88ab67"
import script from "./deleteSegment.vue?vue&type=script&lang=js"
export * from "./deleteSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports